import * as React from 'react';

import * as styles from './styles.css';

interface IBlockHeaderProps {
  children: React.ReactNode;
}

export function BlockSubHeader({ children }: IBlockHeaderProps) {
  return <h4 className={styles['sub-header']}>{children}</h4>;
}
